export enum DialogType {
  MODAL = "modal",
  POPOVER = "popover"
}

export enum DialogSize {
  NONE = "none",
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large"
}
